import { z } from 'zod';
import { ActionStatusSchema } from '../status';
export const MobileServiceSchema = z.object({
    id: z.string(),
    imageUrl: z.string(),
    name: z.string(),
    allowedAmounts: z.array(z.number()),
    serviceTypes: z.array(z.string()).nullable(),
    allowedRange: z.array(z.number()).nullable(),
    enabled: z.boolean(),
    commissionRate: z.number(),
});
export const MobileServiceSchema_BD = MobileServiceSchema.extend({
    serviceId: z.string(),
    vendorId: z.string(),
});
export const MobileTopupTransactionSchema = z.object({
    id: z.string(),
    date: z.string(),
    service: z.object({
        id: z.string(),
        name: z.string(),
        imageUrl: z.string(),
    }),
    amount: z.number(),
    phone: z.string(),
    status: ActionStatusSchema,
});
// ______________________________________________________
// Mobile Topup Report
export const MobileTopupReportSchema = z.object({
    transactions: MobileTopupTransactionSchema.array(),
    accountBalance: z.number(),
    numberOfTransactionsToday: z.number(),
    totalSalesToday: z.number(),
});
// ______________________________________________________
// Mobile Service List
export const MobileServiceListSchema = z.object({
    services: MobileServiceSchema.array(),
    accountBalance: z.number(),
    numberOfTransactionsToday: z.number(),
    totalSalesToday: z.number(),
});
